export const DECK_CONFIG = {
    questionLimit: 10,
    questionLimitRandom: 500,
};
